import { useEffect } from "react";

import { isDateWithSingleRangeValue } from "../../use_filtered_collection/helpers";
import { FiltersData } from "../contexts/marketplace_context.types";
import { useWorkOpportunitiesTab } from "../work_opportunities/hooks/use_work_opportunities_tab";
import { useStartDateFilter } from "./use_start_date_filter";

export const useStartDateFilterUrlSync = (filtersData: FiltersData) => {
  const { setStartDateCondition } = useStartDateFilter();
  const tab = useWorkOpportunitiesTab();

  useEffect(() => {
    if (tab !== "matching_roles") {
      setStartDateCondition(null);
    }
  }, [tab]);

  useEffect(() => {
    if (filtersData.tab !== "matching_roles") {
      return;
    }

    const startDateValue = filtersData.filters.fields?.start_date;

    setStartDateCondition(
      isDateWithSingleRangeValue(startDateValue)
        ? { from: startDateValue.start, to: startDateValue.end }
        : null
    );
  }, [filtersData]);
};
